import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../i18n/translate.js';
import Input from '../../components/Input/Input.js';
import { CODE_WORD_MAX_LENGTH, CODE_WORD_MIN_LENGTH } from '../../services/appConstants/appConstants.js';
import Icon from '../../components/Icon/Icon.js';
import styles from './CodeWordInput.module.scss.js';
import { getValidationErrorLabel } from './useCodeWordInputUtils.js';

function CodeWordInput(_ref) {
  var codeWord = _ref.codeWord,
    type = _ref.type,
    onChange = _ref.onChange,
    error = _ref.error,
    disabled = _ref.disabled,
    isOperator = _ref.isOperator,
    codeExist = _ref.codeExist,
    hideCodeWordState = _ref.hideCodeWordState;
  var validationLabel = getValidationErrorLabel(codeWord);
  var onCodeWordChange = function onCodeWordChange(updatedPart) {
    return onChange(_objectSpread2(_objectSpread2({}, codeWord), updatedPart));
  };
  var codeNotification = codeExist ? /*#__PURE__*/React.createElement("div", {
    className: styles.green
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-checkmark",
    size: "small"
  }), t('MPLIB_CODE_WORD_HAVE_CODE')) : /*#__PURE__*/React.createElement("div", {
    className: styles.error
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-close",
    size: "small"
  }), t('MPLIB_CODE_WORD_MISS_CODE'));
  var notification = hideCodeWordState ? null : codeNotification;
  return /*#__PURE__*/React.createElement("form", {
    id: type
  }, type === 'cus' && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, t('MPLIB_CODE_WORD_CUSTOMER_TITLE')), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t('MPLIB_CODE_WORD_CUSTOMER_DESCRIPTION'))), type === 'sec' && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, t('MPLIB_CODE_WORD_SECURITAS_TITLE')), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t('MPLIB_CODE_WORD_SECURITAS_DESCRIPTION'))), notification, /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(code) {
      return onCodeWordChange({
        code: code
      });
    },
    placeholder: t('MPLIB_NEW_CODE_WORD'),
    dataTestId: "code-word-input-".concat(type),
    value: codeWord.code,
    maxLength: CODE_WORD_MAX_LENGTH,
    disabled: isOperator || disabled
  }), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(confirm) {
      return onCodeWordChange({
        confirm: confirm
      });
    },
    placeholder: t('MPLIB_CONFIRM_CODE_WORD'),
    dataTestId: "code-word-input-confirm-".concat(type),
    value: codeWord.confirm,
    maxLength: CODE_WORD_MAX_LENGTH,
    disabled: isOperator || codeWord.code.length < CODE_WORD_MIN_LENGTH || disabled
  }), validationLabel && /*#__PURE__*/React.createElement("p", {
    className: styles.error
  }, t(validationLabel)), /*#__PURE__*/React.createElement("p", {
    className: styles.error
  }, isOperator && t('MPLIB_CODE_WORD_NO_OPERATOR')), /*#__PURE__*/React.createElement("p", {
    className: styles.error
  }, error && error.description));
}
CodeWordInput.propTypes = {
  codeWord: PropTypes.shape({
    code: PropTypes.string.isRequired,
    confirm: PropTypes.string.isRequired
  }).isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isOperator: PropTypes.bool.isRequired,
  codeExist: PropTypes.bool.isRequired,
  error: PropTypes.shape({
    description: PropTypes.string.isRequired
  }),
  disabled: PropTypes.bool,
  hideCodeWordState: PropTypes.bool
};
CodeWordInput.defaultProps = {
  error: null,
  disabled: false,
  hideCodeWordState: false
};

export { CodeWordInput, CodeWordInput as default };
